import { t } from '@lingui/core/macro';

import { BasicInfo } from '../components/QuickReferralStepForms/BasicInfo';
import { EnrolmentSettings } from '../components/QuickReferralStepForms/EnrolmentSettings';
import { ReviewCourse } from '../components/QuickReferralStepForms/ReviewCourse';
import { SelectCourse } from '../components/QuickReferralStepForms/SelectCourse';
import { Summary } from '../components/QuickReferralStepForms/Summary';

type ReferralStepsContentType = {
  goToNextStep: () => void;
  goToPrevStep: () => void;
  setStep: (step: React.SetStateAction<number>) => void;
};

export const getQuickReferralStepTitles = () => {
  return [
    t`Basic Info`,
    t`Select Course`,
    t`Review Course`,
    t`Enrolment Settings`,
    t`Summary`,
  ] as const;
};

export const getAddNewParticipantStepTitles = () => {
  return [
    t`Basic Info`,
    t`Select Course`,
    t`Review Course`,
    t`Enrolment Settings`,
    t`Summary`,
  ] as const;
};

export const getQuickReferralStepsContent = ({
  goToNextStep,
  goToPrevStep,
  setStep,
}: ReferralStepsContentType) => {
  return [
    <BasicInfo key={getQuickReferralStepTitles()[0]} goToNextStep={goToNextStep} />,
    <SelectCourse
      key={getQuickReferralStepTitles()[1]}
      goToNextStep={goToNextStep}
      goToPrevStep={goToPrevStep}
    />,
    <ReviewCourse
      key={getQuickReferralStepTitles()[2]}
      goToNextStep={goToNextStep}
      goToPrevStep={goToPrevStep}
    />,
    <EnrolmentSettings
      key={getQuickReferralStepTitles()[3]}
      goToNextStep={goToNextStep}
      goToPrevStep={goToPrevStep}
    />,
    <Summary key={getQuickReferralStepTitles()[4]} goToPrevStep={goToPrevStep} setStep={setStep} />,
  ];
};
